import { HorizontalBar } from 'vue-chartjs'
import chart from '@/mixins/chart'
import Utils from '@/utils/charts'
import Colors from '@/utils/chart-options/colors'
import options from '@/utils/chart-options/horizontalLinesBar'

export default {
  extends: HorizontalBar,
  mixins: [chart],
  props: {
    options: {
      type: Object,
      default: () => options
    }
  },
  computed: {
    colors () {
      return {
        prepaid_minute: Colors[0](this),
        mail: Colors[1](this),
        service: Colors[2](this),
        product: Colors[3](this)
      }
    }
  },
  methods: {
    datasetToChartData (dataset) {
      const data = dataset.rows.filter(e => e[1])
      return {
        labels: data.map(e => Utils.label(e[0])),
        datasets: [
          {
            label: this.$t('charts.offerrevenue.label'),
            data: data.map(e => e[1] / 100),
            fill: false,
            barPercentage: 1,
            backgroundColor: data.map(e => this.colors[e[2]]),
            hoverBackgroundColor: data.map(e => this.colors[e[2]]),
            borderColor: data.map(e => this.colors[e[2]]),
            borderWidth: 1
          }
        ]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/charts/offerRevenue.js